var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('folders-list-links-payment',{staticClass:"mt16",attrs:{"items":_vm.payments}}),(_vm.nextLinkPayment)?_c('pagination-panel-default',{attrs:{"if-active":_vm.isLoad},on:{"load-more":_vm.loadMore}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }